import { ArrowLeft, FileText, Loader2, Sparkles } from "lucide-react";
import { useLanguage } from "../../context/LanguageContext";
import { STYLES, VOICES } from "./orderOptions";
import { OrderSelect, optionsFrom } from "./OrderControls";
import { ModelSelector } from "./ModelSelector";

export const StyleStep = ({ order }) => {
  const { t } = useLanguage();
  const { form, set, setStep, isAgreement, pkg, busy, models, submit } = order;
  const validStyle = form.music_style && form.voice;
  const modelReady = models.catalog?.models.some(model => model.id === form.ai_model);
  let SubmitIcon = Sparkles;
  if (isAgreement) SubmitIcon = FileText;
  if (busy) SubmitIcon = Loader2;
  return <div>
    <h2 className="font-display text-xl font-semibold text-slate-100">{t("Music style & voice")}</h2>
    <div className="mt-6 grid gap-5 sm:grid-cols-2">
      <OrderSelect id="music-style" testId="order-step-3-music-style-select" label="Music style" value={form.music_style} onChange={set("music_style")} options={optionsFrom(STYLES)} placeholder="Select a style…" disabled={busy} />
      <OrderSelect id="voice" testId="order-step-3-voice-select" label="Voice" value={form.voice} onChange={set("voice")} options={optionsFrom(VOICES)} placeholder="Select a voice…" disabled={busy} />
    </div>
    {!isAgreement && <div className="mt-6 grid gap-5 border-t border-[#282C3D] pt-6 sm:grid-cols-2" data-testid="order-ai-options">
      <ModelSelector models={models} value={form.ai_model} onChange={set("ai_model")} disabled={busy} />
      <OrderSelect id="lyric-language" testId="order-lyric-language-select" label="Song language" value={form.lyric_language} onChange={set("lyric_language")}
        options={[{ value: "de", label: "Deutsch" }, { value: "en", label: "English" }]} disabled={busy} />
    </div>}
    <div className="mt-6 rounded-xl border border-[#282C3D] bg-[#0E1018] p-4 text-sm text-slate-400" data-testid="order-style-summary">
      <span className="text-[#FFC857]">{t(pkg?.name)}</span> · {t(pkg?.price)}
      {t(isAgreement ? " — pricing by agreement; the studio will send you a personal proposal." : " — you will review and confirm the lyric before any payment.")}
    </div>
    <div className="mt-8 flex flex-wrap justify-between gap-3">
      <button data-testid="order-back-button" onClick={() => setStep(2)} disabled={busy} className="btn-ghost"><ArrowLeft size={16} />{t("Back")}</button>
      <button data-testid="order-submit-button" onClick={submit} disabled={!validStyle || busy || (!isAgreement && !modelReady)} className="btn-primary">
        <SubmitIcon size={16} className={busy ? "animate-spin" : ""} />{t(isAgreement ? "Submit Request" : "Submit & Create My Lyric")}
      </button>
    </div>
  </div>;
};